export default __webpack_public_path__ + "static/protocol-tablet-3f619e1dbc5c85adc1aa714451f0d1a4.png";